import React, { useState } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { FaFolderOpen } from "react-icons/fa";
import { MdFileUpload } from "react-icons/md";
import UploadContentModal from './Modals/upload_video_modal';
import UpdateVideoModal from './Modals/update_video';

export default function Videos({ videos, setOpenVideo, setSelectedProduct, product }: { videos: any, setOpenVideo: (open: boolean) => void, setSelectedProduct: (product: any) => void }) {
    const [openContentModal, setOpenContentModal] = useState(false);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);

    return (
        <div className="w-full flex flex-col items-start justify-between">
            <div className="w-full flex items-center justify-between">
                <div className='flex items-center text-lg font-bold text-white cursor-pointer hover:scale-105'
                    onClick={() => {
                        setOpenVideo(false);
                        setSelectedProduct(null);
                    }}
                >
                    <IoIosArrowBack />
                    <p className="text-sm">Back</p>
                </div>
                <button className="flex items-center gap-x-1 rounded-lg bg-primary px-3 py-2 text-white duration-200 hover:scale-105"
                    onClick={() => setOpenContentModal(true)}
                >
                    <MdFileUpload size={20} />
                    <p className="font-bold text-lg">Upload</p>
                </button>
            </div>
            <div className='w-full flex items-center justify-between'>
                <p className="text-lg font-bold text-white">Content</p>
                <div></div>
            </div>
            <div className="grid grid-cols-3 gap-4 my-4">
                {videos.map((video) => (
                    <div key={video.name} className="bg-white text-black rounded-lg shadow-lg p-4 cursor-pointer">
                        <img src={video.thumb_nail} alt={video.name} className="w-full h-40 object-cover mb-4" />
                        <p className="text-sm font-semibold mb-2">{video.title}</p>
                        <p className="text-gray-600 mb-2">{video.category}</p>
                        <p className="text-gray-600 mb-2">Price: MWK {video.price}</p>
                        <div className="flex items-center justify-between gap-x-3">
                            <div></div>

                            <button className="mt-2 rounded-md bg-primary px-3 py-1 text-white"
                                onClick={() => {
                                    setSelectedVideo(video);
                                    setOpenUpdateModal(true);
                                }}
                            >
                                Edit
                            </button>

                        </div>
                    </div>
                ))}
            </div>
            {openContentModal && <UploadContentModal isOpen={openContentModal} onClose={() => setOpenContentModal(false)} product={product} />}
            {openUpdateModal && <UpdateVideoModal isOpen={openUpdateModal} onClose={() => setOpenUpdateModal(false)} selectedVideo={selectedVideo} product={product} />}
        </div>
    )
}